export default function UnderlineSmall() {

    return (
        <div className="text-sm">
            <div className="bg-amber-600 landscape:w-32 portrait:w-48 h-1 mt-1 mb-5"></div>
        </div >
    );
}
